mutation PurchaseOrderItemCreate($input: PurchaseOrderItemCreateInput!) {
  purchaseOrderItemCreate(input: $input) {
    purchaseOrder {
      id
      _rowTimestamp
      supplierId
      _isDistributionUpdateAllowed
      purchaseOrderTypeId
      purchaseOrderDate
      currencyId
      departmentId
      businessUnitId
      reason
      description
      _subjectToDiscount
      _subjectToTax
      controlTotalAmount
      _isUpdatable
      _isDeletable
      _isRevisable
      purchaseOrderItems(orderBy: _SORT_ITEM_NUMBER_ASC) {
        nodes {
          id
          _rowTimestamp
          _isUpdatable
          _isDeletable
          displayPoItemDescription
          purchaseOrderItemTypeId
          purchaseOrderItemType {
            calculationType
            layoutType
            abbreviation
            description
            id
          }
          _extendedItemTotal
          isTaxable
          isDiscounted
          itemNumber
          itemExtendedAmount
          displayPoItemAccount
          displayPoItemQuantity
          displayPoItemUnitPrice
          displayPoItemType
          description
          itemQuantity
          itemUnitPrice
          displayPoItemTotal
          itemFromDate
          _isActive
          displayPoItemRentalTerm
        }
      }
      _isStagedApprovalRequest
      _requiredApprovalDocuments
      _isApprovalRevocable
      notesByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          id
          _createdByUserName
          _createdDate
          noteComment
          isShared
          _isUpdatable
          _rowTimestamp
          _isDeletable
        }
      }
    }
    purchaseOrderItem {
      id
      _rowTimestamp
      __typename
      purchaseOrderItemTypeId
      purchaseOrderItemType {
        calculationType
        layoutType
        abbreviation
        description
        id
      }
      itemNumber
      _isUpdatable
      _isDeletable
      itemExtendedAmount
      displayPoItemAccount
      displayPoItemQuantity
      displayPoItemUnitPrice
      displayPoItemTotal
      displayPoItemDescription
      displayPoItemRentalTerm
      displayPoItemType
      description
      isTaxable
      isDiscounted
      _extendedItemTotal
      itemQuantity
      itemRentalDates
      itemUnitPrice
      itemFromDate
      purchaseOrderItemType {
        layoutType
        abbreviation
      }
      _isActive
      purchaseOrderItemDistributions {
        nodes {
          id
          _createdDate
          _isDeletable
          _isUpdatable
          _rowTimestamp
          accountReference
          referenceCode6
          referenceCode7
          allocationPercent
          distributionAmount
          productionIncentiveId
          projectReference
          setReference
          tax1099T4TypeId
          referenceCode1
          referenceCode2
          referenceCode3
          referenceCode4
          referenceCode5
        }
      }
    }
  }
}
